import { wearableOperatorABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

let contract: any = null;
const contractAddress = process.env.VUE_APP_WEARABLE_OPERATOR_CONTRACT_ADDRESS;

export const initContract = () => {
  if (window.web3 && contract === null) {
    contract = new window.web3.eth.Contract(wearableOperatorABI, contractAddress);
  }
};

export const wearableTypeClaimed = async (address: string, wearableType: number) => {
  initContract();
  if (!address) {
    return;
  }
  try {
    const claimed = await contract.methods.wearableTypeClaimed(address, wearableType).call();
    return claimed;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const claim = async (wearableType: number, address: string) => {
  initContract();
  if (!address) {
    return;
  }
  try {
    const res = await contract.methods.claim(wearableType).send({
      from: address,
    }).once('sending', () => {
      EventBus.$emit('trx-result', { status: 'loading', trxId: '' });
    }).once('transactionHash', (hash: string) => {
      EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
    }).on('error', (err: MetaError) => {
      metaMaskErrorHandler(err);
    });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};
